import Axios from '../axios'
import { TFunction } from 'i18next'
import { userManager } from '../../../auth/services/auth.service'
import { IAccountStatements } from '../../interfaces/i-api-creaditCard'
import { getHeadersWithJwtToken } from '../../../auth/utils/auth-util'
import { logError } from '../../../shared'
import appConfig from '../../../app.config';

async function getDepositAccountStatementsService(t: TFunction, additionalData?: string) {
    const accountStatementFormat = 'pdf';
    let customerId = await userManager.getUser().then((user) => {
        return user?.profile.sub
    })
    const response = await Axios
        .get<IAccountStatements>(
            `${appConfig.customerDataBaseUrl}/api/deposit/accountstatements?customerId=${customerId}&accountStatementFormat=${accountStatementFormat}&additionalData=${additionalData}`,
            await getHeadersWithJwtToken()
        )
        .then((result) => {
            return result.data as IAccountStatements
        })
        .catch((err) => {
            logError(err)
            if (err.response?.status === 404) {
                throw new Error(t('NoAccountStatements'))
            } else {
                throw err
            }
        })
    return response as IAccountStatements
}

export default getDepositAccountStatementsService;